import { createIntercomEvent, updateIntercom } from '../shared/intercom.js'
import { assignDestinationIds } from './destinationIds.js'
import { isAiCriteriaSource } from '../shared/filterSources.js'
import { normalizeCabin } from '../shared/cabins.js'
import { sameCredential } from '../credentials/credentialFields.js'
import {
  normalizeTransferCodes,
} from '../shared/transferFilters.js'
import { i18n } from "../../entrypoints/plugins/i18n.js";
import { messages } from "../../entrypoints/plugins/main-i18n.js";
const $i18n = i18n(messages).global;

export default {
  changeToken(state, {token}) {
    state.token = token;
  },
  credentials(state, { credentials }) {
    state.credentials = credentials;
  },
  emptyCredentials(state, { emptyCredentials }) {
    state.emptyCredentials = emptyCredentials;
  },
  setAgencies(state, {agencies}) {
    state.agencies = agencies
  },
  updateAgenciesFees(state, { fees, agencyId }) {
    const agencyIndex = state.agencies.findIndex(item => item.id === agencyId);
    const agency = state.agencies[agencyIndex];

    state.agencies[agencyIndex].agency_transaction_fees = agency.agency_transaction_fees.map(originalFee => {
      const updatedFee = fees.find(item => item.id === originalFee.id);

      return updatedFee ? updatedFee : originalFee
    })
  },
  setTickets(state, {tickets}) {
    state.tickets = tickets;
  },
  setAnalytics(state, { analytics }) {
    state.analytics = analytics;
  },
  pushAgency(state, {agency}) {
    state.agencies.push(agency)
  },
  setCompanies(state, {companies}) {
    state.companies = companies
  },
  pushCompany(state, {company}) {
    state.companies.push(company)
  },
  mergeCompany(state, {company}) {
    const stored = state.companies.find((item) => item.id == company.id);
    if (stored) {
      Object.assign(stored, company);
    }
  },
  changeStatus(state, {request}) {
    const parsedRequest = JSON.parse(request)
    state.agencies.map((agency, i) => {
      if (agency.agency_id == parsedRequest.agency_id) {
        state.agencies[i].status = parsedRequest.status;
      }
    })
  },
  changeMainStatus(state, {active}) {
    state.settings.active = active
  },
  changeConsolidatorStatus(state, {active}) {
    state.settings.active_by_supervisor = active
  },
  changeApiKey(state, { token }) {
    state.settings.api_token = token;
  },
  changeCredentialData(state, {credential, channelId}) {
    if (state.agencies.length){
      // Channel ids are unique; an unlinked or shared credential carries no usable agency_id.
      state.agencies.forEach((agency) => {
        (agency.channels || []).forEach((channel) => {
          if (channel.id == channelId) {
            channel.credential = credential;
          }
        })
      })
    } else {
      state.settings.channels.map((channel, i) => {
        if (channel.id == channelId) {
          state.settings.channels[i].credential = credential;
        }
      })
    }
  },
  changePartnersStatus(state, {active, agencyId}) {
    state.agencies = state.agencies.filter((agency) => agency.id != agencyId)
  },
  changeAgenciesStatus(state, {active, companyId}) {
    state.companies = state.companies.filter((company) => company.id != companyId)
  },
  changeCompanyVisibility(state, {shared_bookings, id}) {
    state.companies.map((company) => {
      if (company.id == id) {
        company.shared_bookings = shared_bookings
      }
    })
  },
  changeAdminsChannel(state, {active, channel}){
    state.settings.channels.map((storedChannel, i) => {
      if (storedChannel.title == channel) {
        state.settings.channels[i].active = active
      }
    })
  },
  changeSourceChannel(state, {active, channel, type}){
    state.settings.channels.map((storedChannel, i) => {
      if (storedChannel.title == channel) {
        if (type == 'api') { state.settings.channels[i].api = active }
        if (type == 'web') { state.settings.channels[i].web = active }
        if (type == 'extension') { state.settings.channels[i].extension = active }
      }
    })
  },
  changeSupervisorsChannel(state, { active, stored_form_of_payment, form_of_payment, form_of_payment_product, channelId}){
    state.settings.channels.map((storedChannel) => {
      if (storedChannel.id == channelId) {
        if (active !== undefined) storedChannel.active = active
        if (stored_form_of_payment !== undefined) storedChannel.stored_form_of_payment = stored_form_of_payment
        if (form_of_payment !== undefined) storedChannel.form_of_payment = form_of_payment
        if (form_of_payment_product !== undefined) storedChannel.form_of_payment_product = form_of_payment_product
      }
    })
  },
  changeCompaniesChannel(state, {active, companyId, id}){
    state.companies.map((company) => {
      if (company.id == companyId) {
        company.channels.map((channel) => {
          if (channel.id == id) {
            channel.active = active
          }
        })
      }
    })
  },
  resetStatus(state, {request}) {
    const parsedRequest = JSON.parse(request)
    state.agencies.map((agency) => {
      if (agency.agency_id == parsedRequest.agency_id) {
        agency.status = null
      }
    })
  },
  removeRequest(state, {request}) {
    state.connectionRequests.map((storedrequest, i) => {
      if (storedrequest.id == request.id) {
        state.connectionRequests.splice(i, 1);
      }
    })
  },
  addRequest(state, {request}) {
    const parsedRequest = JSON.parse(request)
    state.connectionRequests.push(parsedRequest)
  },
  addRequests(state, {requests}) {
    state.connectionRequests.push(...requests)
  },
  removeCompany(state, {companyId}) {
    state.companies.map((company, i) => {
      if (company.id == companyId) {
        state.companies.splice(i, 1);
      }
    })
  },
  addManagerToCompany(state, {companyId, request}) {
    state.companies.map((company, i) => {
      if (company.id == companyId && company.avia_managers) {
        state.companies[i].avia_managers.push(request.avia_manager)
      }
    })
  },
  removePartner(state, {id}) {
    state.agencies.map((agency, i) => {
      if (agency.id == id) {
        state.agencies.splice(i, 1);
      }
    })
  },
  updatePartnerChanel(state, {id, channelTitle, channelId}) {
    state.agencies.map((agency, i) => {
      if (agency.id == id) {
        state.agencies[i].channels.map((c, index) => {
          if (c.title == channelTitle) {
            state.agencies[i].channels[index].id = channelId
          }
        })
      }
    })
  },
  removeChanell(state, {agencyId, channelId}) {
    state.agencies.map((agency, i) => {
      if (agency.id == agencyId) {
        state.agencies[i].channels.map((channel, index) => {
          if (channel.id == channelId){
            state.agencies[i].channels[index].id = null
          }
        })
      }
    })
  },
  updateSupervisor(state, {supervisor, partnerId}) {
    state.agencies.map((agency, i) => {
      agency.id
      if (agency.id == partnerId) {
        agency.supervisors.map((storedSupervisor, index) => {
          if (storedSupervisor.id == supervisor.id) {
            state.agencies[i].supervisors[index] = supervisor
          }
        })
      }
    })
  },
  removeSupervisor(state, {supervisorId, partnerId}) {
    state.agencies.map((agency, i) => {
      if (agency.id == partnerId) {
        agency.supervisors.map((storedSupervisor, index) => {
          if (storedSupervisor.id == supervisorId) {
            state.agencies[i].supervisors.splice(index, 1);
            state.agencies[i].supervisors_count = state.agencies[i].supervisors.length
          }
        })
      }
    })
  },
  createSupervisor(state, {supervisor, partnerId}) {
    state.agencies.map((agency, i) => {
      agency.id
      if (agency.id == partnerId) {
        state.agencies[i].supervisors.push(supervisor)
        state.agencies[i].supervisors_count = state.agencies[i].supervisors.length
      }
    })
  },
  removeUser(state, {id, companyId}) {
    state.companies.map((company, i) => {
      if (company.id == companyId && company.avia_managers) {
        company.avia_managers.map((storedManager, index) => {
          if (storedManager.id == id) {
            state.companies[i].avia_managers.splice(index, 1);
          }
        })
      }
    })
  },
  updatePartner(state, {partner}) {
    state.agencies.map((agency, i) => {
      if (agency.id == partner.id) {
        Object.assign(state.agencies[i], partner)
      }
    })
  },
  changePartnersChannel(state, {active, id}) {
    state.agencies.map((agency) => {
      agency.channels.map((channel) => {
        if (channel.id == id) {
          channel.active = active
        }
      })
    })
  },
  setSearchCommand(state, {command, source}) {
    state.searchCommand = {command, source}
  },
  changeChannelNegoCode(state, {negoCode, id}) {
    state.agencies.map((agency) => {
      agency.channels.map((channel) => {
        if (channel.id == id) {
          channel.nego_code = negoCode
        }
      })
    })
  },
  changeChannelResidentFaresCode(state, {residentFaresCode, id}) {
    state.agencies.map((agency) => {
      agency.channels.map((channel) => {
        if (channel.id == id) {
          channel.resident_fares_code = residentFaresCode
        }
      })
    })
  },
  changePartnersAPI(state, {production_api_on, id}) {
    state.agencies.map((agency) => {
      if (agency.id == id) {
        agency.production_api_on = production_api_on
      }
    })
  },
  changePartnersCorporateNumberOn(state, {corporate_number_on, id}) {
    state.agencies.map((agency) => {
      if (agency.id == id) {
        agency.corporate_number_on = corporate_number_on
      }
    })
  },
  changePartnersGhostSegmentsRemarks(state, {ghost_segments_remarks_on, id}) {
    state.agencies.map((agency) => {
      if (agency.id == id) {
        agency.ghost_segments_remarks_on = ghost_segments_remarks_on
      }
    })
  },
  updateBalance(state, {balance, id, company}) {
    state.companies.map((company, i) => {
      if (company.id == id) {
        state.companies[i].balance_amount = balance
        state.company = company
      }
    })
  },
  updateCompanyBalanceUnlimited(state, {unlimited, id}) {
    state.companies.map((company, i) => {
      if (company.id == id) {
        state.companies[i].balance_unlimited = unlimited
      }
    })
  },
  setConnectionRequests(state, {connectionRequests}) {
    state.connectionRequests = connectionRequests
  },
  setSettings(state, {settings}) {
    state.settings = settings
  },
  setFormOfPayments(state, { formOfPayments }) {
    state.formOfPayments = formOfPayments
  },
  setAgencyInfo(state, {angecyInfo}) {
    state.angecyInfo = angecyInfo
  },
  setLoginUI(state, {currentUI}) {
    state.login.currentUI = currentUI
  },
  setLoginEmail(state, {currentEmail}) {
    state.login.currentEmail = currentEmail
  },
  setOnboardingUI(state, {currentUI}) {
    state.onboarding.currentUI = currentUI
  },
  setAccountInfo(state, {accountInfo}) {
    state.accountInfo = Object.assign({}, state.accountInfo, accountInfo)
    const userId = state.accountInfo.drct_id;

    if (state.accountInfo.user_type == "Agent"){
      window.intercomSettings = {
        app_id: "ju18ypiq",
        user_id: state.accountInfo.drct_id,
        name: state.accountInfo.first_name + " " + state.accountInfo.last_name,
        email: state.accountInfo.email,
        phone: state.accountInfo.phone,
        supervisor: false,
        "Registration company": state.accountInfo.company,
        "Partner": state.accountInfo.agencies.map(a => a.name).join(", "),
        "Company": state.accountInfo.companies.join(", "),
        "Channels": getChannelsInfo(state.accountInfo.agencies[0]),
        "hide_default_launcher": oneOfThePartnersIsItTour(state.accountInfo.agencies),
        score: state.accountInfo.score,
        "Recent booking": localStorage.getItem(`${userId}_recent_booking_locator`) || "N/A",
        "Recent channel": localStorage.getItem(`${userId}_recent_channel_code`) || "N/A",
        "Currency": state.accountInfo.agencies[0]?.currency,
        language_override: window.intercomLanguage || 'en',
        locale: window.intercomLanguage || 'en'
      };

    } else if (state.accountInfo.user_type == "Supervisor"){
      window.intercomSettings = {
        app_id: "ju18ypiq",
        user_id: state.accountInfo.drct_id,
        name: state.accountInfo.first_name + " " + state.accountInfo.last_name,
        email: state.accountInfo.email,
        phone: state.accountInfo.phone,
        supervisor: true,
        "Registration company": state.accountInfo.company,
        "Partner": state.accountInfo.agencies[0].name,
        "Company": state.accountInfo.companies.join(", "),
        "Channels": getSupervisorsChannelsInfo(state.settings.channels),
        "hide_default_launcher": isItTour(state.accountInfo.company),
        score: state.accountInfo.score,
        "Recent booking": localStorage.getItem(`${userId}_recent_booking_locator`) || "N/A",
        "Recent channel": localStorage.getItem(`${userId}_recent_channel_code`) || "N/A",
        "Currency": state.accountInfo.agencies[0].currency,
        language_override: window.intercomLanguage || 'en',
        locale: window.intercomLanguage || 'en'
      };

    }

    updateIntercom(window.intercomSettings);
  },
  setAccountEmail(state, {email}) {
    state.accountInfo.email = email
  },
  setAccountPhone(state, {phone}) {
    state.accountInfo.phone = phone
  },
  setAccountName(state, {name}) {
    state.accountInfo.name = name
  },
  setAccountFirstName(state, {name}) {
    state.accountInfo.first_name = name
  },
  setAccountLastName(state, {name}) {
    state.accountInfo.last_name = name
  },
  setAccountCompany(state, {company}) {
    state.accountInfo.company = company
  },
  setRecentBooking(state, { locator, channel }) {
    const userId = state.accountInfo.drct_id;
    localStorage.setItem(`${userId}_recent_booking_locator`, locator);
    localStorage.setItem(`${userId}_recent_channel_code`, channel);

    window.intercomSettings = {
        ...window.intercomSettings,
        "Recent booking": locator,
        "Recent channel": channel,
        language_override: window.intercomLanguage || 'en',
        locale: window.intercomLanguage || 'en'
    };
    updateIntercom(window.intercomSettings); 
},

  deleteAgency(state, {id}) {
    state.accountInfo.agencies = state.accountInfo.agencies.filter(agency => agency.agency_id != id)
  },
  pushNotification(state, {notification}) {
    state.notifications.push(notification)
    setTimeout(() => {
      state.notifications[state.notifications.indexOf(notification)]["start"] = true
    }, 50);

    if (notification.permanent) return false

    if (notification.type == "error") {
      setTimeout(() => {
        this.commit('deleteNotification', {notification})
      }, 15000);
    } else {
      setTimeout(() => {
        this.commit('deleteNotification', {notification})
      }, 4000);
    }

    createIntercomEvent('notification', {
      text: notification.text,
      type: notification.type
    })
  },
  deleteNotification(state, {notification}) {
    const index = state.notifications.indexOf(notification);
    
    // Guard against race condition: only proceed if notification still exists
    if (index === -1) return;
    
    state.notifications[index]["finish"] = true

    setTimeout(() => {
      const currentIndex = state.notifications.indexOf(notification);
      // Check again before splicing in case it was already removed
      if (currentIndex !== -1) {
        state.notifications.splice(currentIndex, 1);
      }
    }, 1000);
  },
  setLastSearchParams(state, { params }) {
    state.lastSearchParams = params
  },
  setSearchResult(state, { result }) {
    state.searchResult = {
      ...state.searchResult,
      ...result,
      origin_destinations: assignDestinationIds(
        result.origin_destinations
          || state.searchResult.origin_destinations
          || []
      ),
      passengers: result.passengers ?? state.searchResult.passengers,
      request_type: result.request_type ?? state.searchResult.request_type,
      request_source: result.request_source ?? state.searchResult.request_source,
      sort: result.sort ?? state.searchResult.sort,
      channels: result.channels ?? state.searchResult.channels,
      search_result_id: result.search_result_id ?? state.searchResult.search_result_id,
      prompts: result.prompts ?? state.searchResult.prompts,
      offers_params: result.offers_params ?? state.searchResult.offers_params,
    };
  },
  replaceSearchResult(state, { result }) {
    state.searchResult = {
      ...result,
      origin_destinations: assignDestinationIds(
        Array.isArray(result?.origin_destinations)
          ? result.origin_destinations
          : []
      )
    }
  },
  clearSearchResult(state) {
    state.searchResult = { origin_destinations: [] }
  },
  addStreamingDestination(state, { destination }) {
    // This mutation is no longer needed since we handle IDs in the action
    // The destinations are already added with proper IDs in searchFlightsStream
  },
  finishStreaming(state) {
    // This mutation can be used to track streaming completion
    // The actual streaming state is managed in the component
  },
  addPriceDetails(state, {details, fareIds, destinationId}) {
    state.searchResult.origin_destinations[destinationId].fares.map(fare => {
      if (fareIds.includes(fare.fare_id)) {
        fare.price.perPass = fare.price.perPass || fare.price.amount
        fare.price.amount = details.price.amount
        fare.price.currency = details.price.currency
        fare.price_detail = details.price_detail
        return fare
      }
    })
  },
  addFaresDetails(state, {details, fareIds, destinationId}) {
    state.searchResult.origin_destinations[destinationId].fares.map(fare => {
      if (fareIds.includes(fare.fare_id)) {
        fare.fare_segments = details.fare_segments
        return fare
      }
    })
  },
  addFlightsDetails(state, {details, fareIds, destinationId}) {
    const dest = state.searchResult.origin_destinations[destinationId]
    dest.flights = details.flights;
    if (details.passenger_attributes?.length) {
      dest.passenger_attributes = [
        ...new Set([...(dest.passenger_attributes || []), ...details.passenger_attributes])
      ]
    }
  },
  addAncillariesDetails(state, {details, fareIds, destinationId}) {
    state.searchResult.origin_destinations[destinationId].ancillaries = details.ancillaries;
  },
  setViDetailsFares(state, { viDetails, destinationId }) {
    const dest = state.searchResult.origin_destinations[destinationId];
    if (!dest || !viDetails?.length) return;

    dest.fares = viDetails;
  },
  setFares(state, {fares, destinationId}) {
    state.searchResult.origin_destinations[destinationId].fares = fares
  },
  removeDestination(state, {id}) {
    state.searchResult.origin_destinations = assignDestinationIds(
      state.searchResult.origin_destinations.filter((destination, i) => i != id)
    )
  },
  setSearchState(state, {currentState}) {
    state.searchState = currentState
  },
  setBookingLoader(state, {currentState}) {
    state.bookingLoader = currentState
  },
  setPriceCalculationError(state, { currentState }) {
    state.priceCalculationError = currentState
  },
  setSearchReissue(state, {currentState}) {
    state.searchReissue = currentState
  },
  setReissueOffers(state, {offers}) {
    state.reissueOffers = offers
  },
  setReissueSearchParams(state, {params}) {
    state.reissueSearchParams = params
  },
  setReissueOffer(state, {offer, destinationId, fareIds}) {
    state.reissueOffers.origin_destinations[destinationId].flights = offer.flights;
    state.reissueOffers.origin_destinations[destinationId].fares.map(fare => {
      if (fareIds.includes(fare.fare_id)) {
        fare.price.perPass = fare.price.perPass || fare.price.amount
        fare.price.amount = offer.price.amount
        fare.price.currency = offer.price.currency
        fare.penalty = offer.penalty
        fare.price_detail = offer.price_detail
        fare.original_price_detail = offer.original_price_detail
        fare.fare_segments = offer.fare_segments
        return fare
      }
    })
  },
  setBookings(state, {bookings}) {
    state.bookings = bookings
  },
  setDefaultBookings(state, {bookings}) {
    state.bookings = bookings
    state.defaultBookings = bookings
  },
  setOpenedBooking(state, {booking}) {
    state.openedBooking = booking
  },
  updateOpenedBookingStatus(state, {provider_status, airline_locators}) {
    state.openedBooking.provider_status = provider_status
    state.openedBooking.airline_locators = airline_locators
  },
  setHiddenBooking(state, {booking}) {
    state.hiddenBooking = booking
  },
  updateBooking(state, {booking}) {
    state.bookings = state.bookings.map(book => {
      if (booking.locator == book.locator) {
        book.cancel_before = booking.cancel_before
        book.price = booking.price
      }
      return book
    })
    state.openedBooking = booking
  },
  removeBooking(state, {locator}) {
    state.bookings = state.bookings.filter(booking => booking.locator != locator)
  },
  changeBookingDetails(state, {locator, cancel_before, status}) {
    const bookings = state.bookings.map(booking => {
      if (booking.locator == locator) {
        if (status) {
          booking.status = status
        }
        booking.cancel_before = cancel_before
        return booking
      }
      return booking
    })
    state.bookings = bookings;
  },
  changeBookingPrice(state, {locator, price}) {
    const bookings = state.bookings.map(booking => {
      if (booking.locator == locator) {
        booking.price = price
        return booking
      }
      return booking
    })
    state.bookings = bookings;
  },
  unsetOpenedBooking(state) {
    state.openedBooking = {}
  },
  removeOpenedBooking(state, {locator}) {
    if (state.openedBooking?.locator === locator) {
      state.openedBooking = {}
    }
    const bookings = state.bookings.filter(booking => booking.locator != locator)
    state.bookings = bookings;
  },
  selectBookingList(state, {selected}) {
    if (selected === "issued" || selected === "exchanged") {
      state.selectedBookingList = "issued"
    } else {
      state.selectedBookingList = selected
    }
  },
  updateAgencyMarkup(state, { markups }) {
    state.angecyInfo.markups = markups
  },
  updateCompanyMarkup(state, { markups, id }) {
    state.companies = state.companies.map((company) => {
      if (company.id == id) {
        company.markups = markups
      }

      return company
    })
  },
  updateChannelsFormOfPayment(state, { agencyId, channelId, card }) {
    if (agencyId == null) {
      state.settings.channels = state.settings.channels.map(channel => {
        if (channel.id == channelId) {
          channel.stored_form_of_payment = card
        }
        
        return channel
      })
    } else {
      state.agencies = state.agencies.map(agency => {
        if (agency.id == agencyId) {
          agency.channels = agency.channels.map(channel => {
            if (channel.id == channelId) {
              channel.stored_form_of_payment = card
            }

            return channel
          })
        }

        return agency
      })
    }
  },
  updateAdminFormOfPayment(state, { cardId, formOfPayment }) {
    const index = state.formOfPayments.findIndex(card => card.id === cardId);
    if (index !== -1) {
      state.formOfPayments.splice(index, 1, { ...state.formOfPayments[index], ...formOfPayment });
    }
  },
  addAdminFormOfPayment(state, { formOfPayment }) {
    state.formOfPayments.push(formOfPayment);
  },
  deleteAdminFormOfPayment(state, { cardId }) {
    state.formOfPayments = state.formOfPayments.filter(card => card.id !== cardId);
  },
  updateAdminCredential(state, { credential }) {
    const index = state.credentials.findIndex(cred => sameCredential(cred, credential));
    if (index !== -1) {
      state.credentials.splice(index, 1, { ...state.credentials[index], ...credential });
    }
  },
  createAdminCredential(state, { credential }) {
    state.credentials = [...state.credentials, credential];
  },
  deleteAdminCredential(state, { credential }) {
    state.credentials = state.credentials.filter(cred => !sameCredential(cred, credential));
  },
  changeAgencyChannel(state, { channelId, attributes }) {
    state.agencies.forEach((agency) => {
      (agency.channels || []).forEach((channel) => {
        if (channel.id == channelId) Object.assign(channel, attributes);
      });
    });
  },
  setAIAskResult(state, {result}) {
    state.aiAskResult = result
  },
  setBookingNotifications(state, {notifications}) {
    state.bookingNotifications = notifications
  },
  deleteBookingNotification(state, {id}) {
    state.bookingNotifications = state.bookingNotifications.filter(notification => notification.id != id)
  },
  deleteExtraFilter(state, {key}) {
    state.extraFilters = state.extraFilters.filter(filter => filter.key !== key)
    const remainingSearchFilters = { ...(state.searchFilters || {}) }
    const keys = filterKeysForExtraKey(key);
    keys.forEach(filterKey => delete remainingSearchFilters[filterKey]);
    state.searchFilters = remainingSearchFilters
    deleteFilterSources(state, keys)
  },
  deleteSearchFilterGroup(state, { keys }) {
    const remainingSearchFilters = { ...(state.searchFilters || {}) };
    keys.forEach(key => delete remainingSearchFilters[key]);
    state.searchFilters = remainingSearchFilters;
    deleteFilterSources(state, keys);
  },
  applyIntent(state, {filters, source, preserveExtraFilters = false, preserveSources = false}) {
    if (source === 'ui' && ('direct' in filters || 'up_to_one_connection' in filters)) {
      state.connectionFilterRevision = (state.connectionFilterRevision || 0) + 1;
    }
    filters = normalizeFilterIntent(filters);
    const previousSearchFilters = state.searchFilters || {};
    const previousExtraFilters = state.extraFilters || [];
    const filterSources = preserveExtraFilters ? { ...(state.searchFilterSources || {}) } : {};
    const replacedFilterKeys = replacementKeys(filters, state);
    replacedFilterKeys.forEach(key => delete filterSources[key]);
    Object.entries(filters).forEach(([key, value]) => {
      if (key === 'response_id') return;
      const active = isActiveFilter(key, value);

      if (active) {
        filterSources[key] = preserveSources && sameFilterValue(previousSearchFilters[key], value)
          ? state.searchFilterSources?.[key] || source
          : source;
      }
      else delete filterSources[key];
    });
    const { 
      exclude_carriers,
      flight_numbers, 
      price_from, 
      price_to, 
      price_currency, 
      cabin,
      nego_fare,
      checked_baggage,
      overnight_transfer,
      cabin_baggage } = filters;

    const extraFilters = transferExtraFilters(filters);

    const excludeCarriersList = Array.isArray(exclude_carriers)
      ? exclude_carriers
      : (exclude_carriers ? [exclude_carriers] : []);

    if(excludeCarriersList.length) {
      extraFilters.push({
        key: 'exclude_carriers',
        value: excludeCarriersList,
        text: (() => {
          const values = excludeCarriersList.join(', ');

          return translatedFilterText('search.exclude', { values }, `Exclude: ${values}`);
        })(),
      });
    }

    const flightNumbersList = Array.isArray(flight_numbers)
      ? flight_numbers
      : (flight_numbers ? [flight_numbers] : []);

    if(flightNumbersList.length) {
      extraFilters.push({
        key: 'flight_numbers',
        value: flightNumbersList,
        text: (() => {
          const values = flightNumbersList.join(', ');
          try {
            return $i18n.t("search.flightNumbers", { flight_numbers: values });
          } catch (error) {
            console.warn('i18n error for search.flightNumbers:', error);
            return `Flight number: ${values}`;
          }
        })(),
      });
    }

    if(price_from && price_to) {
      extraFilters.push({
        key: 'price_range',
        value: `${price_from} — ${price_to}`,
        currency: price_currency || '',
        text: (() => {
          try {
            return $i18n.t("search.priceRange", { price_from, price_to, price_currency: price_currency || '' });
          } catch (error) {
            console.warn('i18n error for search.priceRange:', error);
            return `Price: ${price_from} ${price_currency || ''} — ${price_to} ${price_currency || ''}`;
          }
        })(),
      });
    }

    if(price_from && !price_to) {
      extraFilters.push({
        key: 'price_from',
        value: price_from,
        currency: price_currency || '',
        text: (() => {
          try {
            return $i18n.t("search.priceFrom", { price_from, price_currency: price_currency || '' });
          } catch (error) {
            console.warn('i18n error for search.priceFrom:', error);
            return `Price: from ${price_from} ${price_currency || ''}`;
          }
        })(),
      });
    }

    if (price_to && !price_from) {
      extraFilters.push({
        key: 'price_to',
        value: price_to,
        currency: price_currency || '',
        text: (() => {
          try {
            return $i18n.t("search.priceTo", { price_to, price_currency: price_currency || '' });
          } catch (error) {
            console.warn('i18n error for search.priceTo:', error);
            return `Price: to ${price_to} ${price_currency || ''}`;
          }
        })(),
      });
    }

    if(cabin) {
      extraFilters.push({
        key: 'cabin',
        value: cabin,
        // The enum says "Premium" where the offers say "Premium Economy". The
        // chip names the cabin the way the results do.
        text: normalizeCabin(cabin) || cabin,
      });
    }

    if(nego_fare) {
      extraFilters.push({
        key: 'nego_fare',
        value: nego_fare,
        text: translatedFilterText('search.privateCode', { code: nego_fare }, `Private code: ${nego_fare}`),
      });
    }

    if (checked_baggage !== null && checked_baggage !== undefined) {
      extraFilters.push({
        key: 'checked_baggage',
        value: checked_baggage,
        text: checked_baggage
          ? translatedFilterText('search.checkedBaggageFilter', {}, 'Checked baggage')
          : translatedFilterText('search.withoutCheckedBaggage', {}, 'Without checked baggage'),
      });
    }

    if (cabin_baggage !== null && cabin_baggage !== undefined) {
      extraFilters.push({
        key: 'cabin_baggage',
        value: cabin_baggage,
        text: cabin_baggage
          ? translatedFilterText('search.cabinBaggageFilter', {}, 'Cabin baggage')
          : translatedFilterText('search.withoutCabinBaggage', {}, 'Without cabin baggage'),
      });
    }

    // One chip for the pair: the agent asked for a count, not for a from and a to.
    // A bound the conflict rules just cleared is null, which states no count at all.
    const connectionCount = CONNECTION_COUNT_KEYS
      .map(key => (isActiveFilter(key, filters[key]) ? filters[key] : undefined));

    if (connectionCount.some(bound => bound !== undefined)) {
      extraFilters.push({
        key: 'connections',
        value: connectionCount,
        text: connectionsPromptText(...connectionCount),
      });
    }

    if (overnight_transfer !== null && overnight_transfer !== undefined) {
      extraFilters.push({
        key: 'overnight_transfer',
        value: overnight_transfer,
        text: overnight_transfer
          ? translatedFilterText('search.withOvernight', {}, 'With overnight')
          : translatedFilterText('search.withoutOvernight', {}, 'Without overnight'),
      });
    }

    if (filters.max_connection_time !== null && filters.max_connection_time !== undefined) {
      extraFilters.push({
        key: 'max_connection_time',
        value: filters.max_connection_time,
        text: (() => {
          const hours = Math.ceil(filters.max_connection_time / 60);

          return translatedFilterText('search.connectionUnder', { hours }, `Connection < ${hours} h.`);
        })(),
      });
    }

    const filterState = { ...filters };
    ['response_id', 'recognized', 'cheapest', 'fastest'].forEach(key => delete filterState[key]);
    
    const touchedExtraFilterKeys = extraFilterKeysFor(filters);
    const incomingExtraFilterKeys = new Set(extraFilters.map(filter => filter.key));
    if (preserveExtraFilters) {
      extraFilters.push(...previousExtraFilters.filter(filter => !touchedExtraFilterKeys.has(filter.key)));
    }

    const nextSearchFilters = preserveExtraFilters
      ? { ...(state.searchFilters || {}) }
      : {};
    replacedFilterKeys.forEach(key => delete nextSearchFilters[key]);
    Object.entries(filterState).forEach(([key, value]) => {
      if (isActiveFilter(key, value)) nextSearchFilters[key] = value;
      else delete nextSearchFilters[key];
    });

    state.searchFilters = nextSearchFilters;
    state.searchFilterSources = filterSources;
    state.extraFilters = extraFilters.map(filter => {
      const previous = previousExtraFilters.find(item => item.key === filter.key);

      return {
        ...filter,
        source: preserveExtraFilters && !incomingExtraFilterKeys.has(filter.key)
          ? previous?.source || filter.source
          : sourceForExtraFilter(filter.key, filterSources) || source || previous?.source || 'ai_filter'
      };
    });
  },
  clearDirectFilter(state) {
    if (state.searchFilters.direct !== undefined) {
      state.connectionFilterRevision = (state.connectionFilterRevision || 0) + 1;
      const { direct, ...rest } = state.searchFilters;
      state.searchFilters = rest;
    }
    deleteFilterSources(state, ['direct']);
  },
  clearUpToOneConnectionFilter(state) {
    if (state.searchFilters.up_to_one_connection !== undefined) {
      state.connectionFilterRevision = (state.connectionFilterRevision || 0) + 1;
      const { up_to_one_connection, ...rest } = state.searchFilters;
      state.searchFilters = rest;
    }
    deleteFilterSources(state, ['up_to_one_connection']);
  },
  clearAirportTransferFilter(state) {
    if (state.searchFilters.airport_transfer !== undefined) {
      const { airport_transfer, ...rest } = state.searchFilters;
      state.searchFilters = rest;
    }
    deleteFilterSources(state, ['airport_transfer']);
  },
  clearCarriersFilter(state) {
    if (state.searchFilters.carriers !== undefined) {
      const { carriers, ...rest } = state.searchFilters;
      state.searchFilters = rest;
    }
    deleteFilterSources(state, ['carriers']);
  },
  clearExtraFilters(state) {
    const keys = state.extraFilters.flatMap(filter => filterKeysForExtraKey(filter.key));
    const remainingSearchFilters = { ...(state.searchFilters || {}) };
    keys.forEach(key => delete remainingSearchFilters[key]);
    state.searchFilters = remainingSearchFilters;
    deleteFilterSources(state, keys);
    state.extraFilters = []
  },
  clearSearchFilters(state) {
    state.searchFilters = {}
    state.searchFilterSources = {}
  },
  clearTimeFilters(state) {
    const next = { ...(state.searchFilters || {}) };
    TIME_FILTER_KEYS.forEach(key => delete next[key]);
    state.searchFilters = next;
    deleteFilterSources(state, TIME_FILTER_KEYS);
  },
  setTimeFilters(state, { filters = {}, source = 'ui' } = {}) {
    const next = { ...(state.searchFilters || {}) };
    const sources = { ...(state.searchFilterSources || {}) };

    TIME_FILTER_KEYS.forEach(key => {
      delete next[key];
      delete sources[key];
    });
    TIME_FILTER_KEYS.forEach(key => {
      if (filters[key] === undefined || filters[key] === null) return;

      next[key] = filters[key];
      sources[key] = source;
    });

    state.searchFilters = next;
    state.searchFilterSources = sources;
  },
  clearDurationFilters(state) {
    const durationKeys = Object.keys(state.searchFilters || {}).filter(isDurationFilterKey);
    const remainingSearchFilters = { ...(state.searchFilters || {}) };
    durationKeys.forEach(key => delete remainingSearchFilters[key]);
    state.searchFilters = remainingSearchFilters;
    deleteFilterSources(state, durationKeys);
  },
  // The duration sliders write here like every other filter, so the AI, the
  // counter and the reset button all see the same state.
  setDurationFilters(state, { filters = {}, source = 'ui' } = {}) {
    const next = { ...(state.searchFilters || {}) };
    const sources = { ...(state.searchFilterSources || {}) };

    Object.keys(next).filter(isDurationFilterKey).forEach(key => {
      delete next[key];
      delete sources[key];
    });
    Object.entries(filters).forEach(([key, value]) => {
      if (!isDurationFilterKey(key) || value === undefined || value === null) return;

      next[key] = value;
      sources[key] = source;
    });

    state.searchFilters = next;
    state.searchFilterSources = sources;
  },
  clearAiFilterSources(state) {
    state.searchFilterSources = Object.fromEntries(
      Object.entries(state.searchFilterSources || {}).filter(([, source]) => source !== 'ai_filter')
    );
  },
  setSortPreference(state, { value, source }) {
    if (!value) return;

    const current = state.sortPreference || defaultSortPreference();
    // Sorting asked for in natural language keeps the baseline it replaced, so
    // RESET ALL can come back to it.
    const baseline = isAiCriteriaSource(source)
      ? current.baseline
      : { value, source };
    state.sortPreference = { value, source, baseline };
  },
  clearAiSortPreference(state) {
    if (!isAiCriteriaSource(state.sortPreference?.source)) return;

    const baseline = state.sortPreference.baseline || defaultSortPreference().baseline;
    state.sortPreference = { ...baseline, baseline };
  },
  // Only a search that finished cleanly may name a scope. Anything else has to
  // say null: an interrupted search knows nothing about what is on screen, and
  // claiming "every channel was queried" would silently skip the next refetch.
  setServerCarrierScope(state, { carriers }) {
    state.serverCarrierScope = carriers == null ? null : [...carriers];
  },
  // Undoes an optimistic filter update whose server search failed.
  restoreFilterState(state, { snapshot }) {
    if (!snapshot) return;

    state.searchFilters = { ...snapshot.searchFilters };
    state.searchFilterSources = { ...snapshot.searchFilterSources };
    state.extraFilters = [...snapshot.extraFilters];
    state.serverCarrierScope = snapshot.serverCarrierScope == null
      ? null
      : [...snapshot.serverCarrierScope];
    if (snapshot.sortPreference) state.sortPreference = { ...snapshot.sortPreference };
  }
}

const PRICE_FILTER_KEYS = ['price_from', 'price_to', 'price_currency'];
const CONNECTION_COUNT_KEYS = ['connections_from', 'connections_to'];
const TIME_FILTER_KEYS = [
  'inbound_departure_time_from', 'inbound_departure_time_to',
  'inbound_arrival_time_from', 'inbound_arrival_time_to',
  'outbound_departure_time_from', 'outbound_departure_time_to',
  'outbound_arrival_time_from', 'outbound_arrival_time_to'
];
// No offer carries more than this, so a wider bound states no criterion at all.
const MAX_CONNECTIONS = 3;

function isDurationFilterKey(key) {
  return key.startsWith('takeoff_duration_') || key.startsWith('takeoff_transfer_');
}

function normalizeFilterIntent(filters = {}) {
  const normalized = { ...(filters || {}) };
  const hasAirportTransfer = isActiveFilter('airport_transfer', normalized.airport_transfer);
  const hasCountryTransfer = isActiveFilter('country_transfer', normalized.country_transfer);

  if (hasAirportTransfer) normalized.country_transfer = null;
  if (hasCountryTransfer) normalized.airport_transfer = null;

  // "до 3 пересадок" and "1-3" keep every offer, so they narrow nothing;
  // "більше 3" asks past the ceiling and settles on it. An upper bound equal to
  // the lower one stays: "3 пересадки" is a count, not a pointless limit.
  if (Number.isFinite(normalized.connections_from)) {
    normalized.connections_from = normalized.connections_from <= 0
      ? null
      : Math.min(normalized.connections_from, MAX_CONNECTIONS);
  }
  if (Number.isFinite(normalized.connections_to)
      && normalized.connections_to >= MAX_CONNECTIONS
      && normalized.connections_from !== normalized.connections_to) {
    normalized.connections_to = null;
  }

  const hasConnectionCount = CONNECTION_COUNT_KEYS.some(key => isActiveFilter(key, normalized[key]));

  if (normalized.direct === true) {
    normalized.up_to_one_connection = null;
    normalized.country_transfer = null;
    normalized.overnight_transfer = null;
    CONNECTION_COUNT_KEYS.forEach(key => { normalized[key] = null; });
  } else if (hasConnectionCount) {
    // An exact count says more than either button, so it replaces both.
    normalized.direct = null;
    normalized.up_to_one_connection = null;
  } else if (isActiveFilter('country_transfer', normalized.country_transfer)) {
    normalized.direct = null;
  } else if (normalized.up_to_one_connection === true) {
    normalized.direct = null;
  }

  return normalized;
}

function replacementKeys(filters, state) {
  const keys = new Set();
  const existingKeys = new Set([
    ...Object.keys(state.searchFilters || {}),
    ...Object.keys(state.searchFilterSources || {})
  ]);

  if (filters.price_from !== undefined || filters.price_to !== undefined) {
    PRICE_FILTER_KEYS.forEach(key => keys.add(key));
  }

  Object.keys(filters).forEach(key => {
    const match = key.match(/^(.*)_(from|to)$/);
    if (!match) return;

    existingKeys.forEach(existingKey => {
      if (existingKey.match(new RegExp(`^${match[1]}_(from|to)$`))) keys.add(existingKey);
    });
  });

  return keys;
}

function isActiveFilter(key, value) {
  if (['direct', 'up_to_one_connection'].includes(key)) return value === true;
  return value !== null && value !== undefined && (!Array.isArray(value) || value.length > 0);
}

function extraFilterKeysFor(filters) {
  const keys = new Set(Object.keys(filters || {}));

  if (PRICE_FILTER_KEYS.some(key => keys.has(key))) {
    ['price_range', ...PRICE_FILTER_KEYS].forEach(key => keys.add(key));
  }
  if (CONNECTION_COUNT_KEYS.some(key => keys.has(key))) {
    ['connections', ...CONNECTION_COUNT_KEYS].forEach(key => keys.add(key));
  }

  return keys;
}

function filterKeysForExtraKey(key) {
  if (key === 'price_range' || key.startsWith('price_')) return PRICE_FILTER_KEYS;
  if (key === 'connections') return CONNECTION_COUNT_KEYS;
  if (key.endsWith('_time')) return [`${key}_from`, `${key}_to`];
  return [key];
}

// "2 connections" reads as a count; a single bound reads as a limit. The upper
// bound governs the plural of a range, the way it does when read aloud.
function connectionsPromptText(from, to) {
  if (from !== undefined && to !== undefined) {
    if (from === to) return translatedFilterText('search.connectionsCount', from, `${from} connections`);

    return translatedFilterText('search.connectionsRange', { from, to }, `${from}-${to} connections`, to);
  }
  if (to !== undefined) return translatedFilterText('search.connectionsUpTo', to, `Up to ${to} connections`);

  return translatedFilterText('search.connectionsFrom', from, `From ${from} connections`);
}

function sourceForExtraFilter(key, sources) {
  return filterKeysForExtraKey(key).map(filterKey => sources[filterKey]).find(Boolean);
}

function transferExtraFilters(filters) {
  const prompts = []
  const countryTransfer = normalizeTransferCodes(filters.country_transfer)
  const excludedAirports = normalizeTransferCodes(filters.exclude_airport_transfer)
  const excludedCountries = normalizeTransferCodes(filters.exclude_country_transfer)

  if (countryTransfer.length > 0) {
    prompts.push({
      key: 'country_transfer',
      value: countryTransfer,
      text: translatedFilterText(
        'search.transferThrough',
        { airport_transfer: countryTransfer.join(', ') },
        `Transfer through: ${countryTransfer.join(', ')}`
      ),
    })
  }

  if (excludedAirports.length > 0) {
    prompts.push({
      key: 'exclude_airport_transfer',
      value: excludedAirports,
      text: translatedFilterText(
        'search.exclude',
        { values: excludedAirports.join(', ') },
        `Exclude: ${excludedAirports.join(', ')}`
      ),
    })
  }

  if (excludedCountries.length > 0) {
    prompts.push({
      key: 'exclude_country_transfer',
      value: excludedCountries,
      text: translatedFilterText(
        'search.excludeCountryTransfer',
        { exclude_country_transfer: excludedCountries.join(', ') },
        `Exclude: ${excludedCountries.join(', ')}`
      ),
    })
  }

  return prompts
}

// A number as params is a plural count; an object is named values, and a
// separate plural picks the form when both are needed.
function translatedFilterText(key, params, fallback, plural) {
  try {
    if (plural !== undefined) return $i18n.t(key, params, plural)

    return $i18n.t(key, params)
  } catch (error) {
    console.warn(`i18n error for ${key}:`, error)
    return fallback
  }
}

function sameFilterValue(left, right) {
  const normalize = value => Array.isArray(value) ? [...value].sort() : value;
  return JSON.stringify(normalize(left)) === JSON.stringify(normalize(right));
}

function defaultSortPreference() {
  const baseline = { value: 'smart', source: 'default' };
  return { ...baseline, baseline };
}

function deleteFilterSources(state, keys) {
  const remainingSources = { ...(state.searchFilterSources || {}) };
  keys.forEach(key => delete remainingSources[key]);
  state.searchFilterSources = remainingSources;
}

function getChannelsInfo(agency){
  if (!agency) { return "" }

  return agency.channels.map(el => {
      if (el.active_by_admin &&
          el.active_by_company &&
          el.active_by_main_gate &&
          el.active_by_supervisor &&
          el.active_credential) {
        return el.title
      }
  }).filter(el => el).join(", ")
}

function getSupervisorsChannelsInfo(channels){
  if (!channels) {
    return '';
  }

  return channels.map(el => {
      if (el.active_by_admin &&
          el.active_by_main_gate &&
          el.active &&
          el.credential &&
          el.credential.active) {
        return el.title
      }
  }).filter(el => el).join(", ")
}

function oneOfThePartnersIsItTour(agencies) {
  return agencies.map(a => a.name).includes("IT tour")
}

function isItTour(company) {
  return company == "IT tour"
}
